var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgRefresh = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: [_jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M3.281 6.63A6.19 6.19 0 0 1 9 2.813c2.58 0 4.984 1.72 5.835 4.12m-.116 4.437A6.19 6.19 0 0 1 9 15.188c-2.58 0-4.954-1.7-5.816-4.073" }), _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M15.188 2.25v4.188a.5.5 0 0 1-.5.5H10.5M2.813 15.75v-4.187a.5.5 0 0 1 .5-.5H7.5" })] }))); };
export default SvgRefresh;
